import {
    Calendar,
    ClipboardList,
    CreditCard,
    LayoutDashboard,
    ShieldCheck,
    Smartphone,
    Stethoscope,
    Users
} from "lucide-react";

function Features() {
    return (
        <section id="features" className="py-24 px-4 bg-slate-50">
            <div className="max-w-7xl mx-auto">
                <div className="text-center mb-16 space-y-4">
                    <h2 className="text-primary font-bold tracking-widest uppercase text-sm">Fonctionnalités</h2>
                    <h3 className="text-3xl md:text-4xl font-extrabold text-slate-900">Tout ce dont votre cabinet a besoin</h3>
                </div>
                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {[
                        { icon: <Users size={22}/>, title: "Liste d'attente", desc: "Vue globale sur votre salle d'attente, les patients suivants, ainsi que leurs temps d'arrivés" },
                        { icon: <Calendar size={22}/>, title: "Calendrier Intelligent", desc: "Vues par jour, semaine ou mois. Une visibilité parfaite sur votre planning." },
                        { icon: <ClipboardList size={22}/>, title: "Fiche Patient", desc: "Historique complet, actes réalisés et schéma dentaire interactif." },
                        { icon: <CreditCard size={22}/>, title: "Suivi des Paiements", desc: "Vision claire des payés, partiels et non payés. Gestion éfficace de votre trésorerie." },
                        { icon: <Stethoscope size={22}/>, title: "Soins & Actes", desc: "Catalogue complet (Détartrage, Extraction, Prothèse..) avec tarifs personnalisés." },
                        { icon: <LayoutDashboard size={22}/>, title: "Tableau de Bord", desc: "Nombre de patients, de rendez-vous revenus collectés du jour et alertes importantes." },
                        { icon: <Smartphone size={22}/>, title: "Accès multi-plateforme", desc: "Consultez votre cabinet digitale depuis votre smartphone, tablette en déplacement." },
                        { icon: <ShieldCheck size={22}/>, title: "Gestion d'Équipe", desc: "Accès sécurisés pour le dentiste et l'assistante. Chacun son rôle et ses permissions." }
                    ].map((feat, i) => (
                        <div key={i} className="bg-white p-6 rounded-3xl border border-slate-100 shadow-sm hover:border-primary transition-all group hover:cursor-pointer">
                            <div className="w-12 h-12 bg-blue-50 text-primary rounded-xl flex items-center justify-center mb-4 group-hover:bg-primary group-hover:text-white transition-colors">
                                {feat.icon}
                            </div>
                            <h4 className="text-lg font-bold text-slate-900 mb-2">{feat.title}</h4>
                            <p className="text-sm text-slate-600 leading-relaxed">{feat.desc}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Features;